import { useCallback } from 'react';
import fetchSummary from './fetchAISummary';
import apis from '@api/api';

export const useMessages = ({
	setConversationIdState,
	setAiSummary,
	userId,
}) => {
	const messageIdCallback = useCallback(
		(messageId, messageList) => {
			console.log('📱 messageIdCallback called:', {
				messageId,
				messageListLength: messageList?.length || 0,
				messageListType: typeof messageList,
				isArray: Array.isArray(messageList),
				firstMessage: messageList?.[0],
			});
			
			setConversationIdState(messageId);
			
			const processedMessages =
				messageList.length > 0 ? messageList.reverse() : [];
			console.log('📱 messageIdCallback - Setting messageArray:', {
				originalLength: messageList?.length || 0,
				processedLength: processedMessages.length,
				processedMessages: processedMessages.slice(0, 2), // Show first 2 messages
			});

			// setMessageArray(processedMessages); // This line is removed
			
			try {
				fetchSummary(messageList, userId, setAiSummary);
			} catch (e) {
				console.error('error getting messages', e);
			}
		},
		[userId]
	);

	const getMessagesById = async (convoId) => {
		try {
      return true
			// const res = await apis.getConversation(convoId);
			// if (res.status !== 203) {
			// 	messageIdCallback(
			// 		res.data?.data?._id,
			// 		res.data.data.messages || []
			// 	);
			// 	// handleOpen();
			// }
		} catch (e) {
			console.error('error getting messages', e);
		}
	};

	return {
		messageIdCallback,
		getMessagesById,
	};
};
